import { IDocumentClient } from "@multiweb/clients/documents";
import { ClientType, IClientFactory } from "@multiweb/clients/index";
import { IAttrValue, IDocumentMetadata, IDocumentVersionInfo } from "@multiweb/types/contracts";
import { DIContainer } from "Global/Base/DIContainer";
import { IComparable } from "Global/Base/IComparable";
import { OWManager } from "../OWManager";
import { RequestContext } from "../RequestContext";

export class OWDocumentDescription implements IAttrValue, IComparable {
    private readonly _instanceID: string;
    private readonly _documentClient: IDocumentClient;

    public readonly value: string;
    public readonly attributeName: string;

    private _documentName: Promise<string> = null;
    private _documentHash: Promise<string> = null;
    private _documentMetadata: Promise<IDocumentMetadata> = null;
    private _documentVersions: Promise<IDocumentVersionInfo[]> = null;

    constructor(instanceID: string, attributeName: string, value: string) {
        this._instanceID = instanceID;
        this.value = value;
        this.attributeName = attributeName;
        this._documentClient = DIContainer.instance.create(IClientFactory).get(ClientType.document);
    }

    public async getName(requestContext?: RequestContext): Promise<string> {
        if (this._documentName == null)
            this._documentName = this._documentClient.getDocumentName(this._instanceID, this.attributeName, requestContext);
        return this._documentName;
    }

    public async getHash(requestContext?: RequestContext): Promise<string> {
        if (this._documentHash == null)
            this._documentHash = this._documentClient.getDocumentHashCode(this._instanceID, this.attributeName, requestContext);
        return this._documentHash;
    }

    public async getMetadata(requestContext?: RequestContext): Promise<IDocumentMetadata> {
        if (this._documentMetadata == null)
            this._documentMetadata = this._documentClient.getDocumentMetadata(this._instanceID, this.attributeName, requestContext);
        return this._documentMetadata;
    }

    public async getDocumentVersions(requestContext?: RequestContext): Promise<IDocumentVersionInfo[]> {
        if (this._documentVersions == null)
            this._documentVersions = this._documentClient.getDocumentVersions(this._instanceID, this.attributeName, requestContext);
        return this._documentVersions;
    }

    public createSignature(signature: string, profileId: string, providerType: string, providerVersion: string, requestContext: RequestContext): Promise<string> {
        return OWManager.createDocumentSignature(this._instanceID, this.attributeName, signature, profileId, providerType, providerVersion, requestContext);
    }

    public compare(_value: any): boolean {
        return false; //Neleze rozhodnout jestli je atribut změněný nebo ne, protože se mohla změnit pouze metadata
    }

    private static _properties = ["value", "attributeName"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return typeof (instance) === "object" && instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) && instance instanceof IAttrValue;
    }
}
